module.exports = __webpack_public_path__ + "static/media/beep.988833bf.wav";